import React from 'react';

import IMG_QRCODE from 'assets/slickpay-splash/qr-code-setup-reader.png';
import Space from 'components/generic/Space.component';
import Video from 'components/generic/Video.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './Intro.module.scss';

const VIDEO_SOURCE = 'https://www.youtube.com/embed/OYCKn2-erJc';

const Intro = () => {
  const { t } = useTranslation();
  return (
    <div data-bem="Intro" className={CN.container}>
      <div className={CN.videoContainer} data-bem="Intro__container">
        <Video src={VIDEO_SOURCE} title={t('slickPay.ordered.videoTitle')} />
      </div>
      <div className={CN.backgroundOverlay} data-bem="Intro__backgroundOverlay">
        <div className={CN.title}>
          {t('slickPay.ordered.guidePart1')}
          <Space>
            <span className={CN.marked}>{t('slickPay.ordered.guidePart2')}</span>
          </Space>
          {t('slickPay.ordered.guidePart3')}
        </div>
        <div data-bem="Intro__QR" className={CN.qrCode}>
          <img src={IMG_QRCODE} alt="QR code" className={CN.qrImage} />
          <div className={CN.qrTitle}>{t('slickPay.ordered.qrTitle')}</div>
        </div>
      </div>
    </div>
  );
};
export default Intro;
